import ClientDetailContainer from '../../../containers/ClientDetailContainer'

const ClientDetailPage = () => {
  return <ClientDetailContainer />
}

export default ClientDetailPage
